<template>
  <div class="business-menu">
    <div class="banner-business-menu"></div>
    <div data-v-249f9abc="" class="wrapper clearfix">
      <div data-v-249f9abc="" class="content clearfix">
        <div data-v-63827e5a="" style="position: relative; height: 620px;">
          <div data-v-63827e5a="" class="link-inner">
            <dl data-v-63827e5a="" v-for="(item,i) in business" :key="i" class="item" @click="navTo(item.href)">
              <dd data-v-63827e5a="" :class="[item.ics]"></dd>
              <dt data-v-63827e5a="">{{item.text}}</dt>
            </dl>
            <!-- <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="gh"></dd>
              <dt data-v-63827e5a="">过户</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="cb"></dd>
              <dt data-v-63827e5a="">更改托收银行账号</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="fyjm"></dd>
              <dt data-v-63827e5a="">费用减免</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="btys"></dd>
              <dt data-v-63827e5a="">报停用水</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="hfys"></dd>
              <dt data-v-63827e5a="">恢复用水</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="sbjd"></dd>
              <dt data-v-63827e5a="">水表检定</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="htys"></dd>
              <dt data-v-63827e5a="">核调用水</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="kjbg"></dd>
              <dt data-v-63827e5a="">水表口径变更</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="sbqy"></dd>
              <dt data-v-63827e5a="">水表迁移</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="gxqy"></dd>
              <dt data-v-63827e5a="">供排水管线迁移</dt>
            </dl>
            <dl data-v-63827e5a="" class="item">
              <dd data-v-63827e5a="" class="cbdh"></dd>
              <dt data-v-63827e5a="">抄表到户</dt>
            </dl> -->
          </div>
          <div data-v-63827e5a="" class="content" style="padding-top: 350px;">
            <div data-v-63827e5a="" class="main">
              <div data-v-63827e5a="" class="message-box">
                <div data-v-63827e5a="" class="title">
                  <h4 data-v-63827e5a="">
                    业务指南
                  </h4> <span data-v-63827e5a="" class="more">
                    更多
                    <span data-v-63827e5a=""><i data-v-63827e5a="" class="el-icon-arrow-right"></i></span></span>
                </div>
                <ul data-v-63827e5a="" class="list" style="height: auto;">
                  <li data-v-63827e5a="">单位客户用水报装</li>
                  <li data-v-63827e5a="">个人客户正式用水报装</li>
                  <li data-v-63827e5a="">小型低风险社会投资工程建设项目附属小型供排水报装</li>
                  <li data-v-63827e5a="">单位客户排水报装</li>
                  <li data-v-63827e5a="">抄表到户</li>
                  <li data-v-63827e5a="">委托银行代收费/更改托收银行账号</li>
                </ul>
              </div>
            </div>
            <business-aside />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import businessAside from '../../components/aside'
const BASE_PATH = window.location.href.split('#')[0]
export default {
  data() {
    return {
      business: [
        {
          ics: 'ysbz',
          text: '供排水报装',
          href: BASE_PATH + '#' + '/regret',
        },
        {
          ics: 'gh',
          text: '过户',
          href: BASE_PATH + '#' + '/guohu',
        },
        {
          ics: 'cb',
          text: '更改托收银行账号',
          href: BASE_PATH + '#' + '/cbank',
        },
        {
          ics: 'fyjm',
          text: '费用减免',
          href: BASE_PATH + '#' + '/fyjian',
        },
        {
          ics: 'btys',
          text: '报停用水',
          href: BASE_PATH + '#' + '/baotin',
        },
        {
          ics: 'hfys',
          text: '恢复用水',
          href: BASE_PATH + '#' + '/huiwa',
        },
        {
          ics: 'sbjd',
          text: '水表检定',
          href: BASE_PATH + '#' + '/shuibj'
        },
        {
          ics: 'htys',
          text: '核调用水',
          href: BASE_PATH + '#' + '/hety'
        },
        {
          ics: 'kjbg',
          text: '水表口径变更',
          href: BASE_PATH + '#' + '/shuibk'
        },
        {
          ics: 'sbqy',
          text: '水表迁移',
          href: BASE_PATH + '#' + '/shuibqy'
        },
        {
          ics: 'gxqy',
          text: '供排水管线迁移',
          href: BASE_PATH + '#' + '/gongpgx'
        },
        {
          ics: 'cbdh',
          text: '抄表到户',
          href: BASE_PATH + '#' + '/chaobdh'
        },
      ],
    }
  },
  methods: {
    navTo(href) {
      window.location.href = href
    },
  },
  components: {
    businessAside,
  },
}
</script>
<style>
</style>